function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M-0.000104904 24.4445L-0.000112763 1.35811e-05L24.4443 1.14441e-05L-0.000104904 24.4445Z",
  fill: "#FAB100"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.663 36.361L39.4797 32.5574C39.2819 32.3776 39.0221 32.2818 38.755 32.29C38.4879 32.2983 38.2344 32.41 38.0482 32.6016L35.5855 35.1343C34.9927 35.0211 33.801 34.6495 32.5743 33.4259C31.3475 32.1982 30.976 31.0034 30.8659 30.4147L33.3965 27.951C33.5884 27.7649 33.7003 27.5114 33.7085 27.2443C33.7168 26.9771 33.6208 26.7172 33.4408 26.5195L29.6382 22.3372C29.4581 22.139 29.2079 22.0187 28.9406 22.002C28.6733 21.9853 28.41 22.0734 28.2067 22.2477L25.9735 24.1629C25.7955 24.3414 25.6894 24.5791 25.675 24.8308C25.6596 25.0881 25.3653 31.1825 30.091 35.9102C34.2136 40.0318 39.3778 40.3333 40.8 40.3333C41.0079 40.3333 41.1355 40.3272 41.1695 40.3251C41.4211 40.311 41.6586 40.2043 41.8364 40.0256L43.7505 37.7914C43.9255 37.5887 44.0143 37.3257 43.9979 37.0584C43.9816 36.7911 43.8614 36.5408 43.663 36.361Z",
  fill: "#FAB100"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.25 5.5H35.75C37.2625 5.5 38.5 6.7375 38.5 8.25V25.4274C37.6456 25.0111 36.7215 24.7155 35.75 24.5631V16.5H8.25V35.75H24.5631C24.7155 36.7215 25.0111 37.6456 25.4274 38.5H8.25C6.7375 38.5 5.5 37.2625 5.5 35.75V8.25C5.5 6.7375 6.7375 5.5 8.25 5.5H13.75V2.75H16.5V5.5H27.5V2.75H30.25V5.5ZM8.25 13.75H35.75V8.25H30.25V11H27.5V8.25H16.5V11H13.75V8.25H8.25V13.75Z",
  fill: "#0E185B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "white"
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.dc802f4e.svg";
export { ForwardRef as ReactComponent };